module.exports = {
  defaultTrolley: {
    quantity: 1,
    postCode: '',
    authToken: '',
    URL: '',
    returnURL: '',
    errorViewName: '',
    redirectToBasket: false
  },
  TROLLEY_API_URL: '/basket-api/v1/basket/items'
};